import { Modal }                from '@widesk-ui/components/modal/Modal';
import { BlockedFunctionality } from './engine/types';
import LazyUpgradePrompt        from './LazyUpgradePrompt';

export const renderUpgradePrompt = (blocked: BlockedFunctionality, close: () => void) => (
	<LazyUpgradePrompt blocked={blocked} close={close} />
);

export const openUpgradePrompt = (blocked: BlockedFunctionality) => Modal.open({
	footer: null,
	width: 400,
	children: renderUpgradePrompt(blocked, () => Modal.close()),
});
